<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('atendimento-lps') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('promotor') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('relatorios') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('atendimento-lps') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons"></div>
                    </div>
                    <div class="filters-bar mb-3">
                        <div class="filters-bar-form form-columns-fit">
                            <div class="columns">
                                <div class="column is-6">
                                    <search-bar ref="search" :onSearch="debouncedOnSearch" tooltipLabel="busca-atendimento-lps" />
                                </div>
                                <div class="column is-3">
                                    <verified-date-picker
                                        dateType="startDate"
                                        :value="datainicio"
                                        :endDate="datafim"
                                        title="data-inicio"
                                        @input="changeStartDate"
                                        :showClean="false"
                                        required
                                        :invalid="datainicio == null"
                                    />
                                </div>
                                <div class="column is-3">
                                    <verified-date-picker
                                        dateType="endDate"
                                        :value="datafim"
                                        :startDate="datainicio"
                                        title="data-fim"
                                        @input="changeEndDate"
                                        :showClean="false"
                                        required
                                        :invalid="datafim == null"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="filters-bar-actions">
                            <b-button
                                type="is-primary"
                                icon-right="filter"
                                @click="showFilter = !showFilter"
                                v-tippy 
                                :title="$t('filtros')"
                            />
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="lpsAtendimentoList"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :width="f.width"
                                :label="$t(f.key)"
                                :sortable="f.sortable"
                                v-slot="props"
                                :centered="f.centered"
                            >
                                <div v-if="f.key == 'lps'">
                                    <router-link
                                        :to="{
                                            name: 'promotor-atendimento-lps-list',
                                            params: {
                                                idlps: props.row.id,
                                                data: $moment(props.row.dataatendimento).format(
                                                    'YYYY-MM-DD'
                                                ),
                                            },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'dataatendimento'">
                                    {{ props.row[f.key] | moment('L') }}
                                </div>
                                <template v-else-if="f.key == 'check'">
                                    <a
                                        @click="
                                            lps = props.row;
                                            showModalLpsCheck = true;
                                        "
                                        :title="$t('visualizar')"
                                    >
                                    <b-icon icon="check-all" type="is-primary" />
                                    </a>
                                </template>
                                <template v-else>
                                    {{ props.row[f.key] }}
                                </template>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>

        <lateral-content :isLoading="isLoading" v-model="showFilter" footer>
            <template v-slot:footer-right="{ id }">
                <b-button
                    type="is-warning is-silver"
                    icon-right="backspace"
                    @click="onClearFilters()"
                    class="mr-2"
                    :disabled="isLoading"
                >
                    {{ $t('limpar') }}
                </b-button>
                <b-button
                    type="is-primary"
                    icon-right="filter"
                    @click="
                        carregarDados();
                        showFilter = false;
                    "
                    :disabled="isLoading"
                >
                    {{ $t('filtrar') }}
                </b-button>
            </template>
            <FiltroAtendimento
                ref="filtroRef"
                :filtersReset="filtersReset"
                @update-filtro="updateFiltro"
            />
        </lateral-content>

        <lateral-content
            v-model="showModalLpsCheck"
            :title="lps == null ? $t('check') : lps.lps"
            header
            @input="lps = null"
        >
            <LpsCheckView v-if="lps != null" ref="LpsCheckView" :lps="lps" />
        </lateral-content>

        <router-view />
    </div>
</template>
<script>
import ProLpsService from '@/services/promotor/ProLpsService.js';
import FiltroRelatorioService from '@/services/FiltroRelatorioService.js';
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';
import FiltroAtendimento from '@/components/promotor/relatorio/atendimento/FiltroAtendimento.vue';
import LpsCheckView from '@/components/promotor/relatorio/atendimentoLps/LpsCheckView.vue';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('romotor-atendimento-lps') && to.name != 'promotor-lps-list') {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        FiltroAtendimento,
        ContainerLoader,
        LpsCheckView,
    },
    data() {
        return {
            rotaAninhada: false,

            filtroService: new FiltroRelatorioService(this.$http, this.$router),
            service: new ProLpsService(this.$http, this.$router),

            lpsAtendimentoList: [],
            lps: null,

            fields: [
                { key: 'lps', width: null, sortable: false },
                { key: 'rsocial', width: null, sortable: false },
                { key: 'qtd_atendimentos', width: null, sortable: false, centered: true },
                { key: 'dataatendimento', width: null, sortable: false, centered: true },
                { key: 'check', width: null, sortable: false, centered: true },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            filters: {
                idempresaList: [],
                idcidadeList: [],
                idestadoList: [],
                idregiaoList: [],
                idclienteList: [],
                idusuarioList: [],
                idredeList: [],
                idbandeiraList: [],
                idlpsList: [],
                idcontratoList: [],
                idtiposervicoList: [],
                datainicio: null,
                datafim: null,
                column: 'datahorainc',
                order: 'desc',
                searchQuery: '.*',
                situacao: 2,
            },
            msgs: [],
            showFilter: false,
            filtersReset: false,
            datainicio: new Date(this.$moment().subtract(30, 'days')),
            datafim: new Date(),

            isLoading: false,
            isEmpty: false,

            modalOpen: false,
            debouncedOnSearch: null,
            permissao: {},

            limparFiltro: false,
            showModalLpsCheck: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('romotor-atendimento-lps') && this.$route.name != 'promotor-lps-list';

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            'promotor',
            'relatorios',
            'pro-report-atendimentolps'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos' },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date) {
            if (date.getTime() != this.datainicio.getTime()) {
                this.datainicio = date;
                if (!this.isNull(this.datainicio)) this.carregarDados();
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.datafim.getTime()) {
                this.datafim = date;
                if (!this.isNull(this.datafim)) this.carregarDados();
            }
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.filters.searchQuery = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.fillFilter(currentPage);
        },
        fillFilter(currentPage = 1) {
            this.filters.perPage = this.pagination.perPage;
            this.filters.currentPage = currentPage;
            this.filters.searchQuery = this.filters.searchQuery || '.*';

            this.filters.datainicio = this.datainicio
                ? this.$moment(this.datainicio).format('YYYY-MM-DD')
                : null;
            this.filters.datafim = this.datafim
                ? this.$moment(this.datafim).format('YYYY-MM-DD')
                : null;

            this.carregarDadosAtendimentoLps();
        },
        carregarDadosAtendimentoLps() {
            this.service
                .findAllGroupByAtendomento(this.filters)
                .then(this.mapItems)
                .then((value) => {
                    this.lpsAtendimentoList = value;
                    this.isEmpty = this.lpsAtendimentoList.length <= 0;
                })
                .catch((e) => {
                    this.lpsAtendimentoList = [];
                    this.isEmpty = true;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idlps,
                    idlps: m.idlps,
                    codigo: m.idlpserp,
                    lps: m.nome,
                    rsocial: m.rsocial,
                    qtd_atendimentos: m.qtd_atendimentos,
                    dataatendimento: m.atendimentopda.dataatendimento,
                };
            });
        },
        onClearFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: () => this.clearFilter(),
            });
        },
        clearFilter() {
            this.filtersReset = true;

            this.filters.datainicio = new Date(this.$moment().subtract(30, 'days'));
            this.filters.datafim = new Date();
            this.filters.searchQuery = '.*';

            this.filters.idempresaList = [];
            this.filters.idcidadeList = [];
            this.filters.idestadoList = [];
            this.filters.idregiaoList = [];
            this.filters.idclienteList = [];
            this.filters.idusuarioList = [];
            this.filters.idredeList = [];
            this.filters.idbandeiraList = [];
            this.filters.idlpsList = [];
            this.filters.idcontratoList = [];
            this.filters.idtiposervicoList = [];

            this.$refs.search.cleanSearch();

            setTimeout(() => {
                this.filtersReset = false;
                this.showFilter = false;
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filters[filtro.nomeFiltro] = filtro.valor;
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
    // Filtro lateral
    $width: 400px;
    .filtros-right {
        z-index: 100;
        padding: 15px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        background-color: $darker-bg-color;
        width: $width;
        height: 80%;
        position: fixed;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-top: solid 1px #d9d9d9;
        border-left: solid 1px #d9d9d9;
        border-bottom: solid 1px #d9d9d9;
        transition: 0.6s;
        -webkit-box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);
        box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);

        .filtros-container {
            margin-bottom: 60px;
        }

        .filtros-footer {
            border-bottom-left-radius: 5px;
            background-color: #fff;
            position: absolute;
            padding: 10px;
            bottom: 0;
            left: 0;
            right: 0;
            -webkit-box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
            box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);

            .is-silver {
                color: $semi-title-color;
                box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
                @include exclude-button();
            }
        }
    }
    .hide-filtros-right {
        margin-right: -$width;
    }
    @media screen and (min-height: 850px) {
        .filtros-right {
            height: 50%;
        }
    }
    @media screen and (max-width: 640px) {
        $width: 95%;
        .filtros-right {
            width: $width;
        }
        .hide-filtros-right {
            margin-right: -$width;
        }
    }
}
</style>
